import {
    AuthorizationAuthSuiteService,
    DisconnectDeviceResponseType,
    GetAuthenticationUrlResponseType,
    LinkDeviceWithProviderResponseType,
    GetAuthenticationUrlAuthSuiteRequest,
    LinkDeviceIdWithProviderAuthSuiteRequest,
} from '@cbsi-cbscom/auth-suite-sdk';

export default class AuthSuiteAuthorizationService {
    constructor() {
        this.authorizationService = new AuthorizationAuthSuiteService();
    }

    /**
     * Gets URL to provider's login page
     *
     * @param {GetAuthenticationUrlAuthSuiteRequest} requestData - data passed to the request
     * @returns {Promise<GetAuthenticationUrlResponseType>} - Promise of authenticationUrl
     */
    getAuthenticationUrl = (requestData) => {
        return this.authorizationService.getAuthenticationUrl({
            ...requestData,
        });
    };

    /**
     * Links device ID with given provider
     *
     * @param {LinkDeviceIdWithProviderAuthSuiteRequest} requestData - data required to link device with provider
     * @returns {*|Promise<LinkDeviceWithProviderResponseType>} - Promise of success response object
     */
    linkDeviceWithProvider = (requestData) => {
        return this.authorizationService.linkDeviceWithProvider({
            ...requestData,
        });
    };

    /**
     * Sign out / logout device from AuthSuite service
     * Removes access methods for existing device
     * @param removeTokens
     * @returns {Promise<DisconnectDeviceResponseType>} - Promise of disconnectDevice
     */
    disconnectDevice = async (removeTokens = false) => {
        return this.authorizationService.disconnectDevice(removeTokens);
    };
}
